import React from "react";

const SettingsPage = () => {
    return (
        <div className="p-[20px] bg-gray-200 dark:bg-gray-900 h-dvh">
            <div className="flex items-center justify-center">
                <h1>Settings</h1>
            </div>
        </div>
    );
};

export default SettingsPage;
